@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup" (change)="saveForm()">
    <div formGroupName="periodeNietVerzekerdVoorAOWenANW">
      <div class="row">
        <div class="col col-1 pt-3">
          Periode niet of deels verzekerd voor de AOW en Anw
        </div>
        <div class="col-2">
          <snelstart-ui-date-form-control
            class="custom-input-150"
            formControlName="begindatum"
            id="begindatum"
            label="Begindatum"
          ></snelstart-ui-date-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-date-form-control
            class="custom-input-150"
            formControlName="einddatum"
            id="einddatum"
            label="Einddatum"
          ></snelstart-ui-date-form-control>
        </div>
          <div class="col-3"></div>
      </div>
    </div>
    <div formGroupName="periodeNietVerzekerdVoorWLZenWVZ">
      <div class="row">
        <div class="col col-1">
          Periode niet of deels verzekerd voor de Wlz en Zvw
        </div>
        <div class="col-2">
          <snelstart-ui-date-form-control
            class="custom-input-150"
            formControlName="begindatum"
            id="begindatum"
            label=""
          ></snelstart-ui-date-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-date-form-control
            class="custom-input-150"
            formControlName="einddatum"
            id="einddatum"
            label=""
          ></snelstart-ui-date-form-control>
        </div>
          <div class="col-3"></div>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col col-1">
        Vermindering premie-inkomen
      </div>
      <div class="col-2">
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="verminderingPremieInkomen"
          id="verminderingPremieInkomen"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
        <div class="col-3"></div>
    </div>
    <div class="row">
      <div class="col col-1">
        Correctie premie-inkomen
      </div>
      <div class="col-2">
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="correctiePremieInkomen"
          id="correctiePremieInkomen"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
        <div class="col-3"></div>
    </div>
  </form>
}
